import React, {useState, useEffect }from 'react';

import contexto from '../util/contexto'


const ContextProvider  = ({ children }) => {
    
    const [valorContexto, setValorContexto] = useState(() => {
     
      const savedState = localStorage.getItem('contexto');
      
      return savedState ? JSON.parse(savedState) : {idUsuarioAtual: null, 
                                                    nomeUsuarioAtual: null, 
                                                    idPedido: null, 
                                                    idChat: null, 
                                                    idProposta: null, 
                                                    idItem: null, 
                                                    idLoja: null, 
                                                    privilegio: null, 
                                                    saldoAtual: null, 
                                                    tipoDenuncia: null, 
                                                    idRelacaoDenuncia: null};
    });
  
    useEffect(() => {
        localStorage.setItem('contexto', JSON.stringify(valorContexto));
    }, [valorContexto]);
  
    return (
      <contexto.Provider value={{valorContexto, setValorContexto}}>
        {children}
      </contexto.Provider>
    );
  };


export default ContextProvider;